import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface Benefit {
  id: number;
  title: string;
  description: string;
}

interface BenefitsListProps {
  benefits: Benefit[];
}

const BenefitsList = ({ benefits }: BenefitsListProps) => {
  const { t } = useLanguage();

  return (
    <div className="mt-16">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary text-center mb-12">
        {t('whyGoldSilver.benefits.title')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {benefits.map((benefit) => (
          <div
            key={benefit.id}
            className="bg-card rounded-lg shadow-elevation-sm p-6 hover:shadow-elevation-md transition-smooth"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
                <Icon name="CheckCircleIcon" size={24} variant="solid" className="text-accent" />
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold text-primary mb-2">
                  {benefit.title}
                </h3>
                <p className="font-body text-sm text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsList;